import { useState } from 'react';
import Navbar from '@/components/Navbar';
import Services from '@/components/Services';
import BookingForm from '@/components/BookingForm';
import Footer from '@/components/Footer';

const ServicesPage = () => {
  const [showBooking, setShowBooking] = useState(false);
  const [selectedService, setSelectedService] = useState('');

  const handleBookNow = (serviceName = '') => {
    setSelectedService(serviceName);
    setShowBooking(true);
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar onBookNow={handleBookNow} />
      
      {/* Page Header */}
      <section className="pt-32 pb-12 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Our <span className="gold-gradient">Services</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Professional delivery and hauling solutions for Calgary and surrounding areas
          </p>
        </div>
      </section>

      <Services onBookNow={handleBookNow} />
      <Footer />
      
      {showBooking && (
        <BookingForm 
          isOpen={showBooking} 
          onClose={() => setShowBooking(false)}
          selectedService={selectedService}
        />
      )}
    </div>
  );
};

export default ServicesPage;
